module.exports = __webpack_public_path__ + "img/wm.75b62665.png";